import { motion } from "framer-motion";
import { ClipboardList, UserCheck, PhoneCall } from "lucide-react";

const steps = [
  {
    num: "01",
    icon: ClipboardList,
    title: "Informe o que você precisa",
    text: "Selecione seu estado, cidade e o serviço desejado.",
  },
  {
    num: "02",
    icon: UserCheck,
    title: "Identificamos o profissional adequado",
    text: "Sua solicitação será direcionada ao profissional capacitado para aquela demanda.",
  },
  {
    num: "03",
    icon: PhoneCall,
    title: "Receba o atendimento",
    text: "O profissional responsável entrará em contato para dar continuidade à sua solicitação.",
  },
];

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-it-works-section" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="font-mono-brand text-xs tracking-[0.25em] uppercase text-[#2E9FDB] mb-4">Como funciona</p>
        <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-slate-900 max-w-xl">
          Três passos simples para resolver a documentação do seu veículo
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-14">
        {steps.map((step, i) => (
          <motion.div
            key={step.num}
            data-testid={`step-card-${step.num}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.14, ease: [0.22, 1, 0.36, 1] }}
            className="relative rounded-2xl bg-white border border-slate-200 shadow-sm p-8 overflow-hidden"
          >
            <span className="font-heading font-extrabold text-6xl text-[#0C2340]/[0.06] absolute top-4 right-6 select-none">
              {step.num}
            </span>
            <div className="w-11 h-11 rounded-xl bg-[#2E9FDB]/10 border border-[#2E9FDB]/20 flex items-center justify-center mb-6">
              <step.icon className="w-5 h-5 text-[#2E9FDB]" />
            </div>
            <p className="font-mono-brand text-[10px] tracking-[0.3em] text-slate-500 mb-2">PASSO {step.num}</p>
            <h3 className="font-heading font-semibold text-lg text-slate-900 mb-3">{step.title}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{step.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
